import React from "react";

export default function CampoTecnico() {
  return (
    <div style={{ color: "#030f22" }}>
      <h1 style={{ margin: 0, fontSize: 34, fontWeight: 900 }}>⚡ Campo (Técnico)</h1>
      <p style={{ marginTop: 6, opacity: .75 }}>Aqui vai o conteúdo do campo técnico.</p>
    </div>
  );
}
